<template>
  <div class="item-inner">
    <div class="item-title label" v-if="attribute.sorteditAble === false" style="width: 60%; color: #8e8e93;" >{{this.attribute.label}}</div>
    <div class="item-title label" v-else style="width: 60%;">{{this.attribute.label}}</div>
    <div class="item-input">
      <input type="text" :value="attribute.valueText" placeholder="填写备注" class="open-popup open-goods" data-popup=".popup-text-only" readonly unselectable="on">
      <!--<input type="text"  placeholder="请填写"  v-if="attribute.sorteditAble === false"  :value='attribute.value' disabled="disabled" >-->
      <!--<input type="text" @click="control(attribute)"   placeholder="选填"   v-else-if="attribute.sorteditAble === true && (attribute.columnName === 'TvNoName' || attribute.columnName === 'TvNoNumber') "   v-model="attribute.value" readonly="readonly">-->
      <!--<input type="text" @click="control(attribute)"  placeholder="必填"   v-else   v-model="attribute.value" readonly="readonly">-->
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import {mapState} from 'vuex'
  export default {
    name: 'attr-textarea-box',
    data () {
      return {
        textareaData: ''
      }
    },
    props: [
      'attribute', 'index', 'curAttrsInGroup'
    ],
    mounted () {
    },
    created () {

    },
    computed: {
      ...mapState([
        'remarkData'
      ])
    },
    methods: {
      getAfterText (attribute) {
        var ret = '<div class="modal-class" style="overflow-y: scroll; display: flex">' +
          ' <div style="margin: auto;">' +
          ' <textarea placeholder="请输入..." id="textarea-input-attr" style="height: 8rem;width: 12rem;background-color: #FFFFFF;border: 1px solid #E9E9E9;"></textarea>' +
          ' </div>' +
          ' </div>'
        return ret
      },
      getTitle (attribute) {
        return attribute.label
      },
      control (attribute) {
        let _this = this
        $.modal({
          title: _this.getTitle(attribute),
          afterText: _this.getAfterText(attribute),
          buttons: [
            {
              text: '取消',
              bold: true,
              onClick: function () {
                if (_this.textareaData) {
                  _this.attribute.value = _this.textareaData
//                  _this.attribute.valuetext = _this.textareaData
                }
              }
            },
            {
              text: '确定',
              bold: true,
              onClick: function () {
                let textarea = $('#textarea-input-attr')
                let val = textarea.val()
                _this.attribute.value = val
//                _this.attribute.valuetext = val
                _this.textareaData = val
              }
            }
          ]
        })
        if (attribute.value) {
          $('#textarea-input-attr').val(attribute.value)
        }
        this.$emit('controlForm', this.index, this.curAttrsInGroup)
      }
    },
    watch: {
      'attribute.value': function (val) {
        this.attribute.valueText = val
      },
      'remarkData': function (val) {
        let data = val['/custOrder'].data
//        let dictionary = Emkt.getEmktMetaData().dictionariesMap
//        data['taxName'] = dictionary[61033][data.taxId].dictValue
        this.attribute.value = data
        this.attribute.valueText = data
//        this.$emit('controlForm', this.index, this.curAttrsInGroup)
      }
    }
  }
</script>

<style scoped>
  input {
    border: 1px solid #ccc;
    outline: 0;
    transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  }
  .error input {
    border-color: rgba(246, 58, 56, .8);
    box-shadow: 0 0 8px rgba(246, 58, 56, .6);
  }

</style>



// WEBPACK FOOTER //
// AttrTextArea2Box.vue?cb256bde